import { FormHelperText } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledErrorText = styled(FormHelperText)`
  margin-top: 5px;
`;
